import type { NodeViewRendererProps } from '@tiptap/core';
import type { Node } from '@tiptap/pm/model';
import { ensureImageDimensions } from './image-dimensions';

/** A plain image that stays in the text flow, without block controls or caption. */
export class InlineImageView {
    dom: HTMLImageElement;

    constructor(private props: NodeViewRendererProps) {
        this.dom = props.view.dom.ownerDocument.createElement('img');
        this.dom.onload = () => ensureImageDimensions(this.props, this.dom);
        this.render();
    }

    private render() {
        const { src, alt, title, width, height } = this.props.node.attrs;
        for (const [key, value] of Object.entries({ src, alt, title, width, height })) {
            if (value == null) this.dom.removeAttribute(key);
            else if (this.dom.getAttribute(key) !== String(value)) this.dom.setAttribute(key, String(value));
        }
        // Ensure editor theme rules cannot turn an inline image into a block.
        this.dom.style.display = 'inline';
        this.dom.style.width = width ? `${width}px` : 'auto';
        this.dom.style.height = this.props.node.attrs.responsive ? 'auto' : height ? `${height}px` : 'auto';
        this.dom.style.maxWidth = this.props.node.attrs.responsive ? '100%' : '';
    }

    update(node: Node) {
        if (node.type !== this.props.node.type) return false;
        this.props.node = node;
        this.render();
        return true;
    }

    destroy() { this.dom.onload = null; }
}
